// action Types to fetch redux states
import { actionTypes } from '../actionTypes';

// interfaces
export interface ILoaderState {
    getall41ProjectsStatus: boolean;
    getenclosurePOStatus: boolean;
    getProductionReportsStatus: boolean;
    getproductionSpeedStatus: boolean;
    getsubscriptionReportsStatus: boolean;
    getopenModsReportStatus: boolean;
}

export const loadingReducer = (state: ILoaderState[] = [], action: any) => {

    switch (action.type) {
        ////////////////////////////////////////
        //       FETCHING LOADER REDUCER      //
        ////////////////////////////////////////
        case actionTypes.LOAD_SUBSCRIPTION_REPORTS_BEGIN:
            return { ...state, getsubscriptionReportsStatus: true };

        case actionTypes.LOAD_PRODUCTION_REPORTS_BEGIN:
            return { ...state, getProductionReportsStatus: true };

        case actionTypes.LOAD_PRODUCTION_SPEED_BEGIN:
            return { ...state, getproductionSpeedStatus: true };

        case actionTypes.LOAD_ENCLOSURE_PO_ALL_BEGIN:
            return { ...state, getenclosurePOStatus: true }

        case actionTypes.LOAD_ALL41PROJECTS_BEGIN:
            return { ...state, getall41ProjectsStatus: true }

        case actionTypes.LOAD_OPEN_MODE_REPORT_BEGIN:
            return { ...state, getopenModsReportStatus: true}

        ////////////////////////////////////////
        //       FULFILLED LOADER REDUCER     //
        ////////////////////////////////////////
        case actionTypes.LOAD_SUBSCRIPTION_REPORTS_SUCCESS:
            return { ...state, getsubscriptionReportsStatus: false };

        case actionTypes.LOAD_PRODUCTION_REPORTS_SUCCESS:
            return { ...state, getProductionReportsStatus: false };

        case actionTypes.LOAD_PRODUCTION_SPEED_SUCCESS:
            return { ...state, getproductionSpeedStatus: false };

        case actionTypes.LOAD_ENCLOSURE_PO_ALL_SUCCESS:
            return { ...state, getenclosurePOStatus: false }

        case actionTypes.LOAD_ALL41PROJECTS_SUCCESS:
            return { ...state, getall41ProjectsStatus: false }

        case actionTypes.LOAD_OPEN_MODE_REPORT_SUCCESS:
            return { ...state, getopenModsReportStatus: false }
        ////////////////////////////////////////
        //       FAILED LOADER REDUCER     //
        ////////////////////////////////////////
        case actionTypes.LOAD_SUBSCRIPTION_REPORTS_FAILURE:
            return { ...state, getsubscriptionReportsStatus: false };

        case actionTypes.LOAD_PRODUCTION_REPORTS_FAILURE:
            return { ...state, getProductionReportsStatus: false };

        case actionTypes.LOAD_PRODUCTION_SPEED_FAILURE:
            return { ...state, getproductionSpeedStatus: false };

        case actionTypes.LOAD_ENCLOSURE_PO_ALL_FAILURE:
            return { ...state, getenclosurePOStatus: false }

        case actionTypes.LOAD_ALL41PROJECTS_FAILURE:
            return { ...state, getall41ProjectsStatus: false }

        case actionTypes.LOAD_OPEN_MODE_REPORT_FAILURE:
            return { ...state, getopenModsReportStatus: false }

    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/loading/loading.ts